import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './SettingsPages.css';
import './AppearanceSettings.css';

const mapStyleOptions = [
  { value: 'monochrome', label: 'Monochromatyczny', icon: '⚫' },
  { value: 'light', label: 'Jasny', icon: '☀️' },
  { value: 'subtle', label: 'Stonowany', icon: '🌫️' },
  { value: 'dark', label: 'Ciemny', icon: '🌙' },
  { value: 'default', label: 'Standardowy', icon: '🗺️' },
];

function AppearanceSettings() {
  const { t } = useTranslation(['profile', 'discover']);
  const [mapStyle, setMapStyle] = useState('monochrome');

  useEffect(() => {
    // Load saved style from localStorage
    try {
      const saved = localStorage.getItem('mapStyle');
      if (saved && ['subtle', 'dark', 'light', 'monochrome', 'default'].includes(saved)) {
        setMapStyle(saved);
      }
    } catch (err) {
      console.warn('Failed to load map style from localStorage:', err);
    }
  }, []);

  const handleMapStyleChange = (newStyle) => {
    setMapStyle(newStyle);
    try {
      localStorage.setItem('mapStyle', newStyle);
      // Trigger a custom event to notify the map component
      window.dispatchEvent(new CustomEvent('mapStyleChanged', { detail: { style: newStyle } }));
    } catch (err) {
      console.warn('Failed to save map style to localStorage:', err);
    }
  };

  return (
    <div className="settings-page">
      <div className="settings-page-content">
        {/* Sekcja: Wygląd mapy */}
        <div className="appearance-settings-section">
          <h3 className="appearance-settings-section-title">
            {t('profile.settings.pages.appearance.mapTheme', 'Motyw mapy')}
          </h3>
          <p className="appearance-settings-section-description">
            {t('profile.settings.pages.appearance.mapThemeDescription', 'Wybierz styl wyświetlania mapy. Twoje pinezki pozostaną kolorowe i będą się wyróżniać.')}
          </p>

          <div className="map-style-selector">
            {mapStyleOptions.map((option) => (
              <button
                key={option.value}
                className={`map-style-selector-option ${mapStyle === option.value ? 'active' : ''}`}
                onClick={() => handleMapStyleChange(option.value)}
                type="button"
              >
                <span className="map-style-selector-icon">{option.icon}</span>
                <span className="map-style-selector-label">{option.label}</span>
                {mapStyle === option.value && (
                  <span className="map-style-selector-check">✓</span>
                )}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppearanceSettings;
